import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ui-page" }
const _hoisted_2 = { class: "titlebar" }
const _hoisted_3 = { class: "titlebar-content" }
const _hoisted_4 = { class: "titlebar-title --mobile" }
const _hoisted_5 = { class: "titlebar-text" }
const _hoisted_6 = { class: "titlebar-actions" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "titlebar-actions-secondary" }, null, -1)
const _hoisted_8 = { class: "titlebar-actions-primary" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Salvar")
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "ui-card" }
const _hoisted_12 = { class: "ui-card-body" }
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_15 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-5"
}
const _hoisted_16 = {
  key: 1,
  class: "ant-col ant-col-xs-24 ant-col-xl-5"
}
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-11" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_19 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_21 = { class: "ant-row" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_24 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-4"
}
const _hoisted_25 = {
  key: 1,
  class: "ant-col ant-col-xs-24 ant-col-xl-4"
}
const _hoisted_26 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_27 = { class: "ui-card ui-mt-30" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "ui-header-content-title" }, [
      /*#__PURE__*/_createElementVNode("h4", { class: "ui-card-title" }, [
        /*#__PURE__*/_createElementVNode("span", null, "Informações de Acesso")
      ])
    ])
  ])
], -1)
const _hoisted_29 = { class: "ui-card-body" }
const _hoisted_30 = { class: "ant-row" }
const _hoisted_31 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_32 = { class: "ant-row" }
const _hoisted_33 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_34 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_35 = { class: "ui-card ui-mt-30" }
const _hoisted_36 = { class: "ui-card-header" }
const _hoisted_37 = { class: "ui-card-header-content" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "ui-header-content-title" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "ui-card-title" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Endereços")
  ])
], -1)
const _hoisted_39 = { class: "ui-card-header-content-button" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Novo Endereço")
], -1)
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = { class: "ui-card-body" }
const _hoisted_43 = { class: "ant-row" }
const _hoisted_44 = { class: "ant-col ant-col-xs-24 ant-col-xl-10" }
const _hoisted_45 = ["onUpdate:modelValue"]
const _hoisted_46 = { class: "ant-col ant-col-xs-24 ant-col-xl-10" }
const _hoisted_47 = ["onUpdate:modelValue"]
const _hoisted_48 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_49 = { class: "ant-row" }
const _hoisted_50 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_51 = { class: "ant-col ant-col-xs-24 ant-col-xl-16" }
const _hoisted_52 = ["onUpdate:modelValue"]
const _hoisted_53 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_54 = ["onUpdate:modelValue"]
const _hoisted_55 = { class: "ant-row" }
const _hoisted_56 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_57 = ["onUpdate:modelValue"]
const _hoisted_58 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_59 = ["onUpdate:modelValue"]
const _hoisted_60 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_61 = ["onClick"]
const _hoisted_62 = { class: "ui-button-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_combo_tipo_pessoa = _resolveComponent("combo-tipo-pessoa")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_cpf = _resolveComponent("campo-cpf")!
  const _component_campo_cnpj = _resolveComponent("campo-cnpj")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_campo_telefone = _resolveComponent("campo-telefone")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_combo_genero = _resolveComponent("combo-genero")!
  const _component_combo_finalidade_produtos = _resolveComponent("combo-finalidade-produtos")!
  const _component_campo_email = _resolveComponent("campo-email")!
  const _component_campo_senha = _resolveComponent("campo-senha")!
  const _component_campo_cep = _resolveComponent("campo-cep")!
  const _component_combo_cidade = _resolveComponent("combo-cidade")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_comunicacao_api = _resolveComponent("comunicacao-api")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.appBase.titulo), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "ui-button -primary",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.salvar()))
          }, _hoisted_10)
        ])
      ])
    ]),
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.appBase.carregando
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_a_form_item, { label: "Tipo Pessoa" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_combo_tipo_pessoa, {
                          valor: _ctx.state.cliente.tipoPessoa,
                          "onUpdate:valor": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.cliente.tipoPessoa) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  ((_ctx.state.cliente.tipoPessoa === 1))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createVNode(_component_a_form_item, { label: "CPF" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_cpf, {
                              valor: _ctx.state.cliente.cpfCnpj,
                              "onUpdate:valor": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.cliente.cpfCnpj) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  ((_ctx.state.cliente.tipoPessoa === 2))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createVNode(_component_a_form_item, { label: "CNPJ" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_cnpj, {
                              onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.consultaCnpj())),
                              valor: _ctx.state.cliente.cpfCnpj,
                              "onUpdate:valor": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.cliente.cpfCnpj) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_a_form_item, {
                      label: _ctx.state.cliente.tipoPessoa === 1?'Nome':'Razão Social'
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.cliente.nomeRazaoSocial) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.cliente.nomeRazaoSocial]
                        ])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_a_form_item, { label: "Status" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio_group, {
                          value: _ctx.state.cliente.status,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.cliente.status) = $event)),
                          "button-style": "solid"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_button, { value: false }, {
                              default: _withCtx(() => [
                                _createTextVNode("Inativo")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: true }, {
                              default: _withCtx(() => [
                                _createTextVNode("Ativo")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                ((_ctx.state.cliente.tipoPessoa === 2))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_a_form_item, { label: "Nome Fantasia" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.cliente.nomeFantasia) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.cliente.nomeFantasia]
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_a_form_item, { label: "Telefone" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_telefone, {
                          valor: _ctx.state.cliente.telefone,
                          "onUpdate:valor": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.cliente.telefone) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_a_form_item, {
                      label: _ctx.state.cliente.tipoPessoa === 1?'Data de Nascimento':'Data de Abertura'
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_data, {
                          dataSelecionada: _ctx.state.cliente.dataNascimentoAbertura,
                          "onUpdate:dataSelecionada": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.cliente.dataNascimentoAbertura) = $event))
                        }, null, 8, ["dataSelecionada"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  ((_ctx.state.cliente.tipoPessoa === 1))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createVNode(_component_a_form_item, { label: "Gênero" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_combo_genero, {
                              valor: _ctx.state.cliente.genero,
                              "onUpdate:valor": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.cliente.genero) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ]))
                    : ((_ctx.state.cliente.tipoPessoa === 2))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _createVNode(_component_a_form_item, { label: "Finalidade dos Produtos" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_combo_finalidade_produtos, {
                                valor: _ctx.state.cliente.finalidadeProdutos,
                                "onUpdate:valor": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.cliente.finalidadeProdutos) = $event))
                              }, null, 8, ["valor"])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_a_form_item, { label: "Código ERP" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.cliente.codigoErp) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.cliente.codigoErp]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, [
                _withDirectives(_createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_a_form_item, { label: "Identificação" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.cliente.identificacao) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.cliente.identificacao]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ], 512), [
                  [_vShow, (_ctx.state.cliente.tipoPessoa === 2)]
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(_component_a_form_item, { label: "E-mail" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_email, {
                          valor: _ctx.state.cliente.email,
                          "onUpdate:valor": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.cliente.email) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createVNode(_component_a_form_item, { label: "Senha" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_senha, {
                          valor: _ctx.state.cliente.senha,
                          "onUpdate:valor": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.cliente.senha) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _hoisted_38,
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("button", {
                      class: "ui-button -primary ui-mh-32 ui-full",
                      type: "button",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.adicionarEndereco()))
                    }, _hoisted_41)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createVNode(_component_a_collapse, {
                  activeKey: _ctx.state.chaveEndereco,
                  "onUpdate:activeKey": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.chaveEndereco) = $event)),
                  accordion: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.cliente.enderecos, (endereco, index) => {
                      return (_openBlock(), _createBlock(_component_a_collapse_panel, {
                        key: index,
                        header: _ctx.UtilitarioGeral.valorValido(endereco.identificacao)?endereco.identificacao: (index + 1) +'º Endereço' 
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, [
                              _createVNode(_component_a_form_item, { label: "Identificação" }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    placeholder: "Descreva como você deseja identificar este endereço",
                                    class: "ant-input",
                                    "onUpdate:modelValue": ($event: any) => ((endereco.identificacao) = $event)
                                  }, null, 8, _hoisted_45), [
                                    [_vModelText, endereco.identificacao]
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _createElementVNode("div", _hoisted_46, [
                              _createVNode(_component_a_form_item, { label: "Destinatário" }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    placeholder: "Pessoa ou responsável que vai receber os produtos",
                                    class: "ant-input",
                                    "onUpdate:modelValue": ($event: any) => ((endereco.destinatario) = $event)
                                  }, null, 8, _hoisted_47), [
                                    [_vModelText, endereco.destinatario]
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _createElementVNode("div", _hoisted_48, [
                              _createVNode(_component_a_form_item, { label: "Endereço Principal?" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_radio_group, {
                                    value: endereco.principal,
                                    "onUpdate:value": ($event: any) => ((endereco.principal) = $event),
                                    "button-style": "solid"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_radio_button, { value: false }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Não")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_radio_button, { value: true }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Sim")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["value", "onUpdate:value"])
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("div", _hoisted_50, [
                              _createVNode(_component_a_form_item, { label: "CEP" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_campo_cep, {
                                    onBlur: ($event: any) => (_ctx.consultaCep(index)),
                                    valor: endereco.cep,
                                    "onUpdate:valor": ($event: any) => ((endereco.cep) = $event)
                                  }, null, 8, ["onBlur", "valor", "onUpdate:valor"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _createElementVNode("div", _hoisted_51, [
                              _createVNode(_component_a_form_item, { label: "Endereço/Logradouro" }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "ant-input",
                                    "onUpdate:modelValue": ($event: any) => ((endereco.endereco) = $event)
                                  }, null, 8, _hoisted_52), [
                                    [_vModelText, endereco.endereco]
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _createElementVNode("div", _hoisted_53, [
                              _createVNode(_component_a_form_item, { label: "Número" }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "ant-input",
                                    "onUpdate:modelValue": ($event: any) => ((endereco.numero) = $event)
                                  }, null, 8, _hoisted_54), [
                                    [_vModelText, endereco.numero]
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_55, [
                            _createElementVNode("div", _hoisted_56, [
                              _createVNode(_component_a_form_item, { label: "Complemento" }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "ant-input",
                                    "onUpdate:modelValue": ($event: any) => ((endereco.complemento) = $event)
                                  }, null, 8, _hoisted_57), [
                                    [_vModelText, endereco.complemento]
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _createElementVNode("div", _hoisted_58, [
                              _createVNode(_component_a_form_item, { label: "Bairro" }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "ant-input",
                                    "onUpdate:modelValue": ($event: any) => ((endereco.bairro) = $event)
                                  }, null, 8, _hoisted_59), [
                                    [_vModelText, endereco.bairro]
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _createElementVNode("div", _hoisted_60, [
                              _createVNode(_component_a_form_item, { label: "Cidade/UF" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_combo_cidade, {
                                    codigo: endereco.codigoCidade,
                                    "onUpdate:codigo": ($event: any) => ((endereco.codigoCidade) = $event)
                                  }, null, 8, ["codigo", "onUpdate:codigo"])
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _createElementVNode("button", {
                            class: "ui-button ui-mh-32 ui-full",
                            type: "button",
                            onClick: ($event: any) => (_ctx.removerEndereco(index))
                          }, [
                            _createElementVNode("div", _hoisted_62, [
                              _createElementVNode("div", null, [
                                _createVNode(_component_icone, { nome: "excluir" }),
                                _createTextVNode(" Remover Endereço")
                              ])
                            ])
                          ], 8, _hoisted_61)
                        ]),
                        _: 2
                      }, 1032, ["header"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["activeKey"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }),
    _createVNode(_component_comunicacao_api, {
      visivel: _ctx.appBase.exibirComunicaoApi,
      "onUpdate:visivel": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.appBase.exibirComunicaoApi) = $event)),
      apresentarBarraProgresso: _ctx.appBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.appBase.fraseBarraProgresso,
      resposta: _ctx.appBase.resposta
    }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "resposta"])
  ]))
}